var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconRewrite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    fill: "none",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "master_svg0_25_5147"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 24,
    height: 24,
    rx: 0
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#master_svg0_25_5147)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 4.75,
    y: 3.75,
    width: 14.5,
    height: 16.5,
    rx: 1.25,
    fillOpacity: 0,
    strokeOpacity: 1,
    stroke: "#192038",
    fill: "none",
    strokeWidth: 1.5
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M8,15.25L14,15.25Q14.07387,15.25,14.14632,15.264410999999999Q14.21877,15.278822,14.28701,15.30709Q14.355260000000001,15.335359,14.41668,15.376398Q14.478100000000001,15.417437,14.53033,15.46967Q14.58256,15.521903,14.6236,15.583322Q14.66464,15.644742,14.692910000000001,15.712987Q14.72118,15.781233,14.73559,15.853682Q14.75,15.9261315,14.75,16Q14.75,16.0738685,14.73559,16.146318Q14.72118,16.218767,14.692910000000001,16.287013Q14.66464,16.355258,14.6236,16.416678Q14.58256,16.478096999999998,14.53033,16.53033Q14.478100000000001,16.582563,14.41668,16.623601999999998Q14.355260000000001,16.664641,14.28701,16.69291Q14.21877,16.721178,14.14632,16.735589Q14.07387,16.75,14,16.75L8,16.75Q7.9261315,16.75,7.853682,16.735589Q7.781233,16.721178,7.712987,16.69291Q7.644742,16.664641,7.583322,16.623601999999998Q7.521903,16.582563,7.46967,16.53033Q7.417437,16.478096999999998,7.376398,16.416678Q7.335359,16.355258,7.30709,16.287013Q7.278822,16.218767,7.264411,16.146318Q7.25,16.0738685,7.25,16Q7.25,15.9261315,7.264411,15.853682Q7.278822,15.781233,7.30709,15.712987Q7.335359,15.644742,7.376398,15.583322Q7.417437,15.521903,7.46967,15.46967Q7.521903,15.417437,7.583322,15.376398Q7.644742,15.335359,7.712987,15.30709Q7.781233,15.278822,7.853682,15.264410999999999Q7.9261315,15.25,8,15.25Z",
    fillRule: "evenodd",
    fill: "#192038",
    fillOpacity: 1
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.7071067690849304,0.7071067690849304,-0.7071067690849304,0.7071067690849304,7.788302508556114,-7.762792021579173)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.264670372009277,13.559686534423829C13.264670372009277,13.824896534423829,13.370024372009278,14.079246534423827,13.557555372009277,14.266786534423828L14.733130372009278,15.442386534423829C15.123640372009277,15.832916534423829,15.756800372009277,15.832916534423829,16.14733037200928,15.442416534423828L17.322940372009278,14.266876534423828C17.51049037200928,14.079346534423829,17.615850372009277,13.824986534423829,17.615860372009276,13.559756534423828L17.615940372009277,6.519926534423828C17.615940372009277,5.967638534423828,17.168230372009276,5.519916534423828,16.615940372009277,5.519916534423828L14.264670372009277,5.519916534423828C13.712385372009278,5.519916534423828,13.264670372009277,5.967631534423828,13.264670372009277,6.519916534423828L13.264670372009277,13.559686534423829ZM15.440260372009277,14.028186534423828L14.764670372009277,13.352576534423829L14.764670372009277,7.019916534423828L16.115930372009277,7.019916534423828L16.115860372009276,13.352626534423827L15.440260372009277,14.028186534423828Z",
    fillRule: "evenodd",
    fill: "#192038",
    fillOpacity: 1
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRewrite);
export default __webpack_public_path__ + "static/media/icon_rewrite.d444a62193045f0d339f1c14f19b780a.svg";
export { ForwardRef as ReactComponent };